import { purgeStoredState } from "redux-persist";

export const setToken = accessToken => {
  window.localStorage.setItem("rlspToken", accessToken);

  return accessToken;
};

export const getToken = () => {
  return window.localStorage.getItem("rlspToken");
};

export const deleteToken = () => {
  window.sessionStorage.removeItem("payment_schemes");
  window.sessionStorage.removeItem("unit_meta");
  window.sessionStorage.removeItem("discounts");
  return window.localStorage.removeItem("rlspToken");
};

export const setUserAct = time => {
  window.localStorage.setItem("lastMinAct", time);
};

export const getUserAct = time => {
  return window.localStorage.getItem("lastMinAct");
};

export const deleteUserAct = () => {
  return window.localStorage.removeItem("lastMinAct");
};

export const backToLoginPage = () => {
  deleteToken();
  purgeStoredState();
  window.localStorage.clear();
  window.location.href = "/";
};

export const restoreNewLead = data => {
  window.localStorage.setItem("newLead", JSON.stringify(data));
};

export const getNewLead = () => {
  if (window.localStorage.getItem("newLead")) {
    return JSON.parse(window.localStorage.getItem("newLead"));
  }
  return null;
};

export const removeNewLead = () => {
  window.localStorage.removeItem("newLead");
};
